import React from 'react'
import { CobuStack, CobuText } from '@cobu/ui'
import type { PlaceCategory } from '@cobu/types'
import { CATEGORY_META, getCategoryLabel } from './categoryMeta'

export function CategoryBadge({ category }: { category: PlaceCategory }) {
  const meta = CATEGORY_META[category]
  const Icon = meta.icon

  return (
    <CobuStack
      layout="horizontal"
      ai="center"
      gap="$1"
      px="$2"
      py="$1"
      br="$full"
      bg={meta.backgroundColor as any}
    >
      <Icon style={{ fontSize: 12 }} />
      <CobuText variant="caption" fow="600" color={meta.color as any}>
        {getCategoryLabel(category)}
      </CobuText>
    </CobuStack>
  )
}
